import { render, staticRenderFns } from "./MyReport.vue?vue&type=template&id=0cb23b8a&"
import script from "./MyReport.vue?vue&type=script&lang=js&"
export * from "./MyReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports